import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["hasAssociatedSubscription", "associatedSubscriptionId", "isPaymentCollectedAutomatically", "updatePreview", "onClickButton"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { SUBSCRIPTION_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { actions } from '../../constants/actions';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const RecordPaymentButton = _ref => {
  let {
      hasAssociatedSubscription,
      associatedSubscriptionId,
      isPaymentCollectedAutomatically,
      updatePreview,
      onClickButton
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const tooltipTitle = buttonProps.disabled && isPaymentCollectedAutomatically ? hasAssociatedSubscription ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "invoices.components.invoiceActionsDropdown.tooltips.subscriptionInvoice.recordPayment_jsx",
    elements: {
      UILink: Link
    },
    options: {
      onClick: () => associatedSubscriptionId && updatePreview(SUBSCRIPTION_TYPE_ID, associatedSubscriptionId.toString())
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.invoiceActionsDropdown.tooltips.subscriptionInvoice.recordPaymentNoSubscription"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.invoiceActionsDropdown.tooltips.pending.recordPayment"
  });
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !buttonProps.disabled,
    title: tooltipTitle,
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "record-payment-btn",
      use: "tertiary-light",
      responsive: false,
      size: "extra-small",
      onClick: () => onClickButton(actions.RECORD_PAYMENT),
      disabled: buttonProps.disabled,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.invoiceActionsDropdown.buttons.recordPayment"
      })
    }, "record-payment-btn")
  }, "record-payment-btn");
};
export default RecordPaymentButton;